import React from 'react';

export default function ProgressBar({ value, color = 'var(--primary)' }) {
  const bg = value >= 100 ? 'var(--success)' : value >= 50 ? color : 'var(--warning)';
  return (
    <div className="progress-bar">
      <div className="progress-bar-fill" style={{ width: `${Math.min(value, 100)}%`, background: bg }} />
    </div>
  );
}
